export const PhoneConfigs = [
     {
        title: "Dung lượng",
        content: "256GB/ 521GB",
    },
    {
        title: "Màn hình",
        content: "6,3”. Màn hình Super Retina XDR ",
    },
    {
        title: "Độ phân giải màn hình",
        content: "Màn hình Super Retina OLED XDR 6,3 inch",
    },
    {
        title: "Camera sau:",
        content: "Hệ thống camera 48MP Dual Fusiont",
    },
    {
        title: "Camera trước:",
        content:
            "Camera 18MP Center Stage. Khẩu độ ƒ/1.9",
    },
    {
        title: "Pin",
        content: "Thời gian xem video. Lên đến 30 giờ",
    },
     {
        title: "Sạc:",
        content: "USB-C, Magsafe",
    },
    {
        title: "Kết nối mạng",
        content: "SIM kép (nano SIM và eSIM). Hỗ trợ eSIM kép",
    },
    {
        title: "Chip:",
        content: "Chip A19<br>CPU 6 lõi với 2 lõi hiệu năng và 4 lõi tiết kiệm điện. GPU 5 lõi với Neural Accelerator<br>Neural Engine 16 lõi",
    },
    {
        title: "RAM",
        content: "Chưa có thông tin đề cập",
    },
      {
        title: "Bảo mật",
        content: "Face ID, Apple Intelligence, iOS 26",
    },
      {
        title: "Chống nước",
        content: "Đạt mức IP68 (chống nước ở độ sâu tối đa 6 mét trong vòng tối đa 30 phút) theo tiêu chuẩn IEC 60529",
    },
   
    
    // {
    //     title: "Chống nước",
    //     content:
    //         "IP68 (độ sâu tối đa 6 mét trong tối đa 30 phút) theo tiêu chuẩn IEC 60529",
    // },
];
export const PhoneAirConfigs = [
     {
        title: "Dung lượngww",
        content: "256GB/ 521GssB",
    },
    {
        title: "Màn hình",
        content: "6,3”. Màn hình Super Retina XDR ",
    },
    {
        title: "Độ phân giải màn hình",
        content: "Màn hình Super Retina OLED XDR 6,3 inch",
    },
    {
        title: "Camera sau:",
        content: "Hệ thống camera 48MP Dual Fusiont",
    },
    {
        title: "Camera trước:",
        content:
            "Camera 18MP Center Stage. Khẩu độ ƒ/1.9",
    },
    {
        title: "Pin",
        content: "Thời gian xem video. Lên đến 30 giờ",
    },
     {
        title: "Sạc:",
        content: "USB-C, Magsafe",
    },
    {
        title: "Kết nối mạng",
        content: "SIM kép (nano SIM và eSIM). Hỗ trợ eSIM kép",
    },
    {
        title: "Chip:",
        content: "Chip A19<br>CPU 6 lõi với 2 lõi hiệu năng và 4 lõi tiết kiệm điện. GPU 5 lõi với Neural Accelerator<br>Neural Engine 16 lõi",
    },
    {
        title: "RAM",
        content: "Chưa có thông tin đề cập",
    },
      {
        title: "Bảo mật",
        content: "Face ID, Apple Intelligence, iOS 26",
    },
      {
        title: "Chống nước",
        content: "Đạt mức IP68 (chống nước ở độ sâu tối đa 6 mét trong vòng tối đa 30 phút) theo tiêu chuẩn IEC 60529",
    },
   
    
    // {
    //     title: "Chống nước",
    //     content:
    //         "IP68 (độ sâu tối đa 6 mét trong tối đa 30 phút) theo tiêu chuẩn IEC 60529",
    // },
];

export const AirPodConfigs = [
    {
        title: "Thời lượng pin tai nghe",
        content: "6 giờ",
    },
    {
        title: "Thời lượng pin hộp sạc",
        content: "30 giờ",
    },
    {
        title: "Cổng sạc",
        content: "Sạc MagSafe, Lightning, Sạc không dây Qi",
    },
    {
        title: "Công nghệ âm thanh",
        content: "Active Noise Cancellation, Chip Apple H2, Adaptive EQ",
    },
    {
        title: "Tiện ích",
        content:
            "Chống nước IPX4, Sạc không dây, Trợ lý ảo Siri, Có mic thoại, Sạc nhanh",
    },
    {
        title: "Công nghệ kết nối",
        content: "Bluetooth 5.3",
    },
    {
        title: "Phím điều khiển",
        content:
            "Nghe/nhận cuộc gọi, Phát/dừng chơi nhạc, Chuyển bài hát, Tăng/giảm âm lượng, Bật trợ lí ảo, Chuyển chế độ, Bật/Tắt chống ồn",
    },
    {
        title: "Kích thước",
        content: "Dài 3.09 cm - Rộng 2.18 cm - Cao 2.17 cm",
    },
    {
        title: "Khối lượng",
        content: "5.3 g",
    },
    {
        title: "Tương thích",
        content: "Android, iOS, Windows",
    },
];

export const WatchConfigs = [
    {
        title: "Công nghệ màn hình",
        content: "OLED",
    },
    {
        title: "Kích thước mặt",
        content: "1.9 inch",
    },
    {
        title: "Kích thước màn hình",
        content: "45 mm",
    },
    {
        title: "Chất liệu mặt",
        content: "Kính Spaphire",
    },
    {
        title: "Chất liệu khung viền",
        content: "Thép không gỉ",
    },
    {
        title: "Chất liệu dây",
        content: "Silicone",
    },
    {
        title: "Độ rộng dây",
        content: "Hãng không công bố",
    },
    {
        title: "Độ dài dây",
        content: "Hãng không công bố",
    },
    {
        title: "Khả năng tăng dây",
        content: "Có",
    },
    {
        title: "Kích thước, khối lượng",
        content: "Dài 45mm - Ngang 38mm - Dày 10.7mm - Nặng 38.8g",
    },
    {
        title: "Sim & nghe gọi",
        content: "Qua eSIM (nghe gọi độc lập không cần qua điện thoại)",
    },
    {
        title: "Tiện ích đặc biệt",
        content:
            "Màn hình luôn hiển thị, phát hiện té ngã, kếu nối bluetooth với tai nghe",
    },
];
